import {
  bucketsFromAggregationWithMatches,
  validGroups,
} from './service-facet-helpers/normalizing-facet';
import {
  buildServiceGroupsFromCodes,
  groupsFromBucketsWithoutCptMetadata,
} from './service-facet-helpers/grouping-attributes';

export function buildServiceFacetGroups(store, buckets, { includeZeroDocCounts = true } = {}) {
  let { list, docCountByKey } = bucketsFromAggregationWithMatches(buckets, {
    includeZeroDocCounts,
  });

  let codes = store.peekAll('cpt-code').toArray();
  if (!codes.length) {
    if (!list.length) {
      return [];
    }
    return groupsFromBucketsWithoutCptMetadata(list);
  }

  let groups = buildServiceGroupsFromCodes(codes, docCountByKey);
  return validGroups(groups) ? groups : groupsFromBucketsWithoutCptMetadata(list);
}
